import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';
import RaisedButton from 'material-ui/RaisedButton';
import _ from 'lodash'
import {
    Table,
    TableBody,   
    TableRow,
    TableRowColumn,
  } from 'material-ui/Table';
import selfPayComsumablestore from '../store/SelfPayComsumablestore';
import { observer } from 'mobx-react'

const styles ={
    tableTitleColumn: {
        width: "35%",
        fontWeight: 700,
        fontSize:"14px",
        whiteSpace: 'normal',
        wordWrap: 'break-word',
        paddingRight: 0
    },
    tableContentColumn:{
        whiteSpace: 'normal',
        wordWrap: 'break-word',
    }
}




class ResultDialog extends Component {
    constructor(props){
        super(props)
        this.state={
            loaddata: false,
        }
    }

    handleClick = (val) => {
        selfPayComsumablestore.setToggleDialog(val);           
       };
        
   
    

    
       
    render() {   
            
            
             
        return (                 
              <div style={{marginBottom: "10px", width: "100%"}}>                              
                <RaisedButton 
                label={this.props.alldata.CODE_NAME} 
                style={{width: "100%", height:"70px",display:"flex"}}
                labelStyle={{alignItems:"center", display: "block", lineHeight:"35px"}}
                onClick={() => this.handleClick(this.props.ordernum)}/>
                <Dialog               
                title={this.props.alldata.CODE_NAME}               
                modal={true}
                open={this.props.isOpen}
                actions={ [<FlatButton label="結束" primary={true} onClick={() => this.handleClick(this.props.ordernum)} />
                    ]}
                contentStyle={{width: "100%", "maxWidth": "414px"}}
                >
                <Table height="300px">
                    <TableBody displayRowCheckbox={false}>
                        <TableRow>
                            <TableRowColumn style={styles.tableTitleColumn}>自費特材健保碼</TableRowColumn>
                            <TableRowColumn style={styles.tableContentColumn}>{this.props.alldata.NHI_CODE}</TableRowColumn>
                        </TableRow>
                        <TableRow>
                            <TableRowColumn style={styles.tableTitleColumn}>中文醫令名稱(商品名)</TableRowColumn>
                            <TableRowColumn style={styles.tableContentColumn}>{this.props.alldata.CODE_NAME}</TableRowColumn>
                        </TableRow>
                        <TableRow>
                            <TableRowColumn style={styles.tableTitleColumn}>英文醫令名稱[學名]</TableRowColumn>
                            <TableRowColumn style={styles.tableContentColumn}>{this.props.alldata.DRUG_NAME}</TableRowColumn>
                        </TableRow>

                         <TableRow>
                            <TableRowColumn style={styles.tableTitleColumn}>自付金額</TableRowColumn>
                            <TableRowColumn style={styles.tableContentColumn}>{this.props.alldata.STD_PRICE}</TableRowColumn>
                        </TableRow>
                        <TableRow>
                            <TableRowColumn style={styles.tableTitleColumn}>產品用途與特性</TableRowColumn>
                            <TableRowColumn style={styles.tableContentColumn}>{this.props.alldata.SPEC}</TableRowColumn>
                        </TableRow>
                        <TableRow>
                            <TableRowColumn style={styles.tableTitleColumn}>副作用</TableRowColumn>
                            <TableRowColumn style={styles.tableContentColumn}>{this.props.alldata.SIDE_EFFECT}</TableRowColumn>
                        </TableRow>
                        <TableRow>
                            <TableRowColumn style={styles.tableTitleColumn}>使用注意事項</TableRowColumn>
                            <TableRowColumn style={styles.tableContentColumn}>{this.props.alldata.NOTICES}</TableRowColumn>
                        </TableRow>
                        <TableRow>
                            <TableRowColumn style={styles.tableTitleColumn}>相較健保產品差異</TableRowColumn>
                            <TableRowColumn style={styles.tableContentColumn}>{this.props.alldata.NHI_DIFF}</TableRowColumn>
                        </TableRow>
                        <TableRow>
                            <TableRowColumn style={styles.tableTitleColumn}>供應商</TableRowColumn>
                            <TableRowColumn style={styles.tableContentColumn}>{this.props.alldata.SUPPLIER}</TableRowColumn>
                        </TableRow> 
                        <TableRow>
                            <TableRowColumn style={styles.tableTitleColumn}>許可證號</TableRowColumn>
                            <TableRowColumn style={styles.tableContentColumn}>{this.props.alldata.NHI_IDNO}</TableRowColumn>
                        </TableRow>
                                           
                        <TableRow>
                            <TableRowColumn style={styles.tableTitleColumn}>健保審議狀態</TableRowColumn>
                            <TableRowColumn style={styles.tableContentColumn}>{this.props.alldata.NHI_STATUS_NAME}</TableRowColumn>
                        </TableRow> 
                        <TableRow>
                            <TableRowColumn style={styles.tableTitleColumn}>健保給付上限</TableRowColumn>
                            <TableRowColumn style={styles.tableContentColumn}>{this.props.alldata.NHI_PRICE}</TableRowColumn>
                        </TableRow>                    
                        
                        
                       
                        {_.map(this.props.alldata.image_arr, (item, key)=>{
                                                        
                            return(<TableRow key={key}>
                                <TableRowColumn style={styles.tableTitleColumn}>圖片{parseInt(key)+1}</TableRowColumn>
                                <TableRowColumn style={styles.tableContentColumn}>
                                <img className="result_img" src={item}/>                            
                                </TableRowColumn>
                            </TableRow>)
                        })}                         
                       
                       
                        {/* <TableRow>
                            <TableRowColumn style={styles.tableTitleColumn}>特材類別</TableRowColumn>                           
                            <TableRowColumn style={styles.tableContentColumn}>{this.props.alldata.NHI_TYPE}</TableRowColumn>
                        </TableRow>                                            */}
                     </TableBody>
                    </Table>           
                </Dialog>
                
                </div>


        )
    }
    }


export default observer(ResultDialog);


// WEBPACK FOOTER //
// ./src/components/layout/ResultDialog.js